import type React from 'react';

import {
  IconButton,
  type IconButtonProps,
  withStyles,
} from '@material-ui/core';

import { CloseIcon } from '../../icons';

import { colors } from '../../styles';

export interface CloseButtonProps extends IconButtonProps {
  fill?: string;
  hoverFill?: string;
  hoverBackground?: string;
}

const StyledCloseButton = withStyles(() => ({
  root: {
    color: (props: CloseButtonProps) => props.fill || colors.gray.default,
    padding: 0,

    '&:hover': {
      backgroundColor: (props: CloseButtonProps) =>
        props.hoverBackground || 'transparent',
      color: (props: CloseButtonProps) => props.hoverFill || colors.gray.dark,
    },
  },
}))((props: CloseButtonProps) => {
  const { fill, hoverFill, hoverBackground, ...otherProps } = props;

  return <IconButton {...otherProps} />;
});

export const CloseButton: React.FC<CloseButtonProps> = (props) => (
  <StyledCloseButton
    data-testid='close-button'
    disableRipple
    size='small'
    {...props}
  >
    <CloseIcon />
  </StyledCloseButton>
);
